import { ElAffix } from '@code-monkey-ui/components/affix'
import { ElAlert } from '@code-monkey-ui/components/alert'
import { ElAutocomplete } from '@code-monkey-ui/components/autocomplete'
import { ElAvatar } from '@code-monkey-ui/components/avatar'
import { ElBacktop } from '@code-monkey-ui/components/backtop'
import { ElBadge } from '@code-monkey-ui/components/badge'
import { ElBatch } from '@code-monkey-ui/components/batch'
import {
  ElBreadcrumb,
  ElBreadcrumbItem,
} from '@code-monkey-ui/components/breadcrumb'
import { ElButton, ElButtonGroup } from '@code-monkey-ui/components/button'
import { ElCalendar } from '@code-monkey-ui/components/calendar'
import { ElCard } from '@code-monkey-ui/components/card'
import { ElCarousel, ElCarouselItem } from '@code-monkey-ui/components/carousel'
import { ElCascader } from '@code-monkey-ui/components/cascader'
import { ElDshCascader } from '@code-monkey-ui/components/dsh-cascader'
import { ElCascaderPanel } from '@code-monkey-ui/components/cascader-panel'
import { ElDshCascaderPanel } from '@code-monkey-ui/components/dsh-cascader-panel'
import { ElCheckTag } from '@code-monkey-ui/components/check-tag'
import {
  ElCheckbox,
  ElCheckboxButton,
  ElCheckboxGroup,
} from '@code-monkey-ui/components/checkbox'
import { ElCol } from '@code-monkey-ui/components/col'
import { ElCollapse, ElCollapseItem } from '@code-monkey-ui/components/collapse'
import { ElCollapseTransition } from '@code-monkey-ui/components/collapse-transition'
import { ElColorPicker } from '@code-monkey-ui/components/color-picker'
import { ElConfigProvider } from '@code-monkey-ui/components/config-provider'
import {
  ElAside,
  ElContainer,
  ElFooter,
  ElHeader,
  ElMain,
} from '@code-monkey-ui/components/container'
import { ElDatePicker } from '@code-monkey-ui/components/date-picker'
import {
  ElDescriptions,
  ElDescriptionsItem,
} from '@code-monkey-ui/components/descriptions'
import { ElDialog } from '@code-monkey-ui/components/dialog'
import { ElDivider } from '@code-monkey-ui/components/divider'
import { ElDrawer } from '@code-monkey-ui/components/drawer'
import {
  ElDropdown,
  ElDropdownItem,
  ElDropdownMenu,
} from '@code-monkey-ui/components/dropdown'
import { ElEmpty } from '@code-monkey-ui/components/empty'
import { ElForm, ElFormItem } from '@code-monkey-ui/components/form'
import { ElIcon } from '@code-monkey-ui/components/icon'
import { ElImage } from '@code-monkey-ui/components/image'
import { ElImageViewer } from '@code-monkey-ui/components/image-viewer'
import { ElInput } from '@code-monkey-ui/components/input'
import { ElInputNumber } from '@code-monkey-ui/components/input-number'
import { ElLink } from '@code-monkey-ui/components/link'
import {
  ElMenu,
  ElMenuItem,
  ElMenuItemGroup,
  ElSubMenu,
} from '@code-monkey-ui/components/menu'
import { ElPageHeader } from '@code-monkey-ui/components/page-header'
import { ElPagination } from '@code-monkey-ui/components/pagination'
import { ElPopconfirm } from '@code-monkey-ui/components/popconfirm'
import { ElPopover } from '@code-monkey-ui/components/popover'
import { ElPopper } from '@code-monkey-ui/components/popper'
import { ElProgress } from '@code-monkey-ui/components/progress'
import {
  ElRadio,
  ElRadioButton,
  ElRadioGroup,
} from '@code-monkey-ui/components/radio'
import { ElRate } from '@code-monkey-ui/components/rate'
import { ElResult } from '@code-monkey-ui/components/result'
import { ElRow } from '@code-monkey-ui/components/row'
import { ElScrollbar } from '@code-monkey-ui/components/scrollbar'
import {
  ElOption,
  ElOptionGroup,
  ElSelect,
} from '@code-monkey-ui/components/select'
import {
  ElDshOption,
  ElDshOptionGroup,
  ElDshSelect,
} from '@code-monkey-ui/components/dsh-select'
import { ElSelectV2 } from '@code-monkey-ui/components/select-v2'
import { ElSkeleton, ElSkeletonItem } from '@code-monkey-ui/components/skeleton'
import { ElSlider } from '@code-monkey-ui/components/slider'
import { ElSpace } from '@code-monkey-ui/components/space'
import { ElStatistic } from '@code-monkey-ui/components/statistic'
import { ElCountdown } from '@code-monkey-ui/components/countdown'
import { ElStep, ElSteps } from '@code-monkey-ui/components/steps'
import { ElSwitch } from '@code-monkey-ui/components/switch'
import { ElTable, ElTableColumn } from '@code-monkey-ui/components/table'
import { ElAutoResizer, ElTableV2 } from '@code-monkey-ui/components/table-v2'
import { ElTabPane, ElTabs } from '@code-monkey-ui/components/tabs'
import { ElTag } from '@code-monkey-ui/components/tag'
import { ElText } from '@code-monkey-ui/components/text'
import { ElTimePicker } from '@code-monkey-ui/components/time-picker'
import { ElTimeSelect } from '@code-monkey-ui/components/time-select'
import { ElTimeline, ElTimelineItem } from '@code-monkey-ui/components/timeline'
import { ElTooltip } from '@code-monkey-ui/components/tooltip'
import { ElTooltipV2 } from '@code-monkey-ui/components/tooltip-v2'
import { ElTransfer } from '@code-monkey-ui/components/transfer'
import { ElTree } from '@code-monkey-ui/components/tree'
import { ElTreeSelect } from '@code-monkey-ui/components/tree-select'
import { ElTreeV2 } from '@code-monkey-ui/components/tree-v2'
import { ElUpload } from '@code-monkey-ui/components/upload'
import { ElWatermark } from '@code-monkey-ui/components/watermark'
import { ElWeekPicker } from '@code-monkey-ui/components/week-picker'

import type { Plugin } from 'vue'

export default [
  ElAffix,
  ElAlert,
  ElAutocomplete,
  ElAutoResizer,
  ElAvatar,
  ElBacktop,
  ElBadge,
  ElBatch,
  ElBreadcrumb,
  ElBreadcrumbItem,
  ElButton,
  ElButtonGroup,
  ElCalendar,
  ElCard,
  ElCarousel,
  ElCarouselItem,
  ElDshCascader,
  ElCascader,
  ElCascaderPanel,
  ElDshCascaderPanel,
  ElCheckTag,
  ElCheckbox,
  ElCheckboxButton,
  ElCheckboxGroup,
  ElCol,
  ElCollapse,
  ElCollapseItem,
  ElCollapseTransition,
  ElColorPicker,
  ElConfigProvider,
  ElContainer,
  ElAside,
  ElFooter,
  ElHeader,
  ElMain,
  ElDatePicker,
  ElDescriptions,
  ElDescriptionsItem,
  ElDialog,
  ElDivider,
  ElDrawer,
  ElDropdown,
  ElDropdownItem,
  ElDropdownMenu,
  ElEmpty,
  ElForm,
  ElFormItem,
  ElIcon,
  ElImage,
  ElImageViewer,
  ElInput,
  ElInputNumber,
  ElLink,
  ElMenu,
  ElMenuItem,
  ElMenuItemGroup,
  ElSubMenu,
  ElPageHeader,
  ElPagination,
  ElPopconfirm,
  ElPopover,
  ElPopper,
  ElProgress,
  ElRadio,
  ElRadioButton,
  ElRadioGroup,
  ElRate,
  ElResult,
  ElRow,
  ElScrollbar,
  ElSelect,
  ElOption,
  ElOptionGroup,
  ElDshSelect,
  ElDshOption,
  ElDshOptionGroup,
  ElSelectV2,
  ElSkeleton,
  ElSkeletonItem,
  ElSlider,
  ElSpace,
  ElStatistic,
  ElCountdown,
  ElSteps,
  ElStep,
  ElSwitch,
  ElTable,
  ElTableColumn,
  ElTableV2,
  ElTabs,
  ElTabPane,
  ElTag,
  ElText,
  ElTimePicker,
  ElTimeSelect,
  ElTimeline,
  ElTimelineItem,
  ElTooltip,
  ElTooltipV2,
  ElTransfer,
  ElTree,
  ElTreeSelect,
  ElTreeV2,
  ElUpload,
  ElWatermark,
  ElWeekPicker,
] as Plugin[]
